// CMS API integration for Larsen & Kristensen

const API_BASE = 'https://api.dev.auxo.dk';

/**
 * Fetches all items from a CMS collection.
 * Uses the simple array endpoint for fixed lists.
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE}/public/content/${collectionName}?t=${Date.now()}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch Error (${collectionName}):`, error);
    return [];
  }
}

/**
 * Fetches a single page by its page_slug
 */
export async function fetchPageBySlug(slug) {
  const pages = await fetchCollection('pages');
  return pages.find(p => p.page_slug === slug || p.slug?.da === slug) || null;
}

/**
 * Fetches a gallery by its page_slug
 */
export async function fetchGalleryBySlug(slug) {
  const galleries = await fetchCollection('gallery');
  return galleries.find(g => g.page_slug === slug) || null;
}

/**
 * Helper to get Cloudflare resized image URL
 */
export function getResizedImageUrl(url, width = 800, quality = 80) {
  if (!url || !url.startsWith('https://assets.auxodev.dk')) return url;
  // Make sure we don't double wrap
  if (url.includes('/cdn-cgi/image/')) return url;
  
  const origin = 'https://assets.auxodev.dk';
  const path = url.substring(origin.length);
  return `${origin}/cdn-cgi/image/width=${width},quality=${quality},format=auto${path}`;
}
